import { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { ILayoutWithOwner } from '../../factories/layout-factory';
import { IActionModalLayout } from '../../types/layout/action-modal';
import Modal, { IModalRefs } from '../modal';
import useLayout from '../../hooks/layout/useLayout';
import { LayoutContext } from '../../contexts/layout';

function ActionModal(props: IActionModalLayout & ILayoutWithOwner) {
    const {
        className, disabled, title, layoutLink,
    } = props;
    const modal = useRef<IModalRefs>();
    const { layoutId } = useContext(LayoutContext);
    const { clearLayout, updateLayout } = useLayout(layoutId, true);
    const { objectId } = useParams();

    const openModal = () => modal.current?.show(layoutLink, undefined, objectId);

    const onHide = () => {
        clearLayout();
        updateLayout();
    };

    return (
        <>
            <button disabled={disabled} type="button" className={className || 'btn btn-primary'} onClick={openModal}>
                {title}
            </button>
            <Modal ref={modal} idOwner={objectId} onHide={onHide} />
        </>
    );
}

export default ActionModal;
